var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 510.184 510.184",
    style: {
      enableBackground: "new 0 0 510.184 510.184"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "310.709,182.099 256.873,73.069 203.1,182.099 82.808,199.556 169.849,284.419 149.292,404.238 256.873,347.686     364.518,404.238 343.966,284.419 430.996,199.556   ",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#09D3AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.092,0C114.435,0,0.005,114.43,0.005,255.098c0,140.662,114.43,255.085,255.086,255.085    c140.651,0,255.086-114.424,255.086-255.085C510.19,114.43,395.766,0,255.092,0z M255.092,486.27    c-127.467,0-231.171-103.704-231.171-231.171c0-127.479,103.704-231.184,231.171-231.184s231.171,103.705,231.171,231.184    C486.275,382.565,382.571,486.27,255.092,486.27z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#09D3AC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.6b49806e6366e02d3bcb4fa41ff52e23.svg";
export { ForwardRef as ReactComponent };